import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import { useElementHover } from '@vueuse/core';
import { useBreakpoint } from '~/composables';
import CatalogCategoryItemImages from '~/components/sections/categorySection/CatalogCategoryItemImages.vue';

interface Props {
  link?: string;
  title?: string;
  text?: string;
  image?: any;
  images?: any;
  styles?: any;
  variation?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CatalogCategoryItem',
  props: {
    link: { default: '' },
    title: { default: '' },
    text: { default: '' },
    image: { default: () => ({}) },
    images: { default: () => ({}) },
    styles: { default: () => ({}) },
    variation: { default: '' }
  },
  setup(__props: any) {

const props = __props as { link: string, title: string, text: string, image: any, images: any, styles: any, variation: string };

const variations: Record<string, { [key: string]: string }> = {
  title: {
    default: 'tracking-[0.12em] text-xs text-slate sm:text-sm 2xl:text-lg',
    catalog: 'text-xl md:text-3xl',
  },
};


const { isBiggerThanBreakpoint: isDesktop } = useBreakpoint('md');
const el = ref();
const hover = useElementHover(el as any);

const titleClasses = computed(() => variations.title[props.variation]);

return { __sfc: true,variations, props, isDesktop, el, hover, titleClasses, CatalogCategoryItemImages }
}

})